import { Avatar, Text } from '@mantine/core';

const organizationInitials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

const initialsFontSize = (initials: string, avatarSize: number) => {
  const fontSizeScale = initials.length > 4 ? 0.2 : initials.length > 2 ? 0.25 : 0.325;

  return Math.round(avatarSize * fontSizeScale);
};

export default function OrganizationAvatar({
  organizationName,
  size = 40,
  selected = false,
}: {
  organizationName: string;
  size?: number;
  selected?: boolean;
}) {
  const initials = organizationInitials(organizationName);

  return (
    <Avatar
      data-organization-avatar={initials}
      name={organizationName}
      color='initials'
      variant={selected ? 'filled' : 'light'}
      autoContrast
      size={size}
      radius={6}
    >
      <Text component='span' fw={700} fz={initialsFontSize(initials, size)} lh={1}>
        {initials}
      </Text>
    </Avatar>
  );
}
